import React from "react";
import { Document, Page, Text, View, StyleSheet, Image } from "@react-pdf/renderer";

import logo from "../../assets/images/logo.png"; // Adjust the path as necessary
import ioclogo from "../../assets/images/io-logo.png"; // Adjust the path as necessary
const styles = StyleSheet.create({
  page: {
    padding: 10,
    fontSize: 10,
    fontFamily: "Times-Roman",
  },
  header: {
    textAlign: "center",
    marginLeft: "0",
    marginRight: "0",
    paddingLeft: 10,
    paddingRight: 10,
  },
  headerRow: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
    felx:1,
    marginBottom: 10,
  },
  logo: {
    width: "40px",
    height: "40px",
    display: "inline-block",
  },
  tableRow: {
    flexDirection: "row",
    alignItems: "center",
  },
  cell: {
    border: "1pt solid black",
    padding: 5,
    flex: 1,
  },
  bold: {
    fontWeight: "bold",
  },
  right: {
    textAlign: "right",
  },
  columnStyles: {
    vehicle: { flex: 2 },
    date: { flex: 1.5 },
    qty: { flex: 1, textAlign: "right" },
    price: { flex: 1, textAlign: "right" },
    grossAmount: { flex: 1.5, textAlign: "right" },
    discount: { flex: 1, textAlign: "right" },
    netAmount: { flex: 1.5, textAlign: "right" },
    status: { flex: 1.5 },
  },
});

const columnStyles = {
  vehicle: { flex: 2 },
  date: { flex: 1.2 },
  qty: { flex: 0.8 },
  price: { flex: 0.8 },
  grossAmount: { flex: 1.2 },
  discount: { flex: 0.8 },
  netAmount: { flex: 1.2 },
  paid: { flex: 1.2 },
  due: { flex: 1.2 },
  status: { flex: 1 },
};

const ReportPdf = ({ data = [] }) => {
  const customer = data[0];

  return (
    <Document>
      <Page size="A4" style={styles.page}>
        {/* Header */}
        <View style={styles.headerRow}>
          <Image src={ioclogo} style={styles.logo} />
        <View style={styles.header}>
            <Text style={{ fontSize: 12, fontWeight: "bold",  }}>
             &nbsp;&nbsp;&nbsp; NAMASHKAR FUEL ENERGY OPC PVT
            </Text>
            <Text>U/26, kashi Plaza, Kamrej Gam Road, Kamrej. Surat-394185 </Text>
            <Text>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Mob: 9265568766 | GST No. 24AAICN3700B1Z4</Text>
          </View>
          <Image src={logo} style={styles.logo} />
          </View>

        {/* Customer & Phone */}
        <View style={styles.tableRow}>
          <Text style={[styles.cell, { flex: 2 }]}>
            Customer: <Text style={styles.bold}>{customer.name}</Text>
          </Text>
          <Text style={[styles.cell, { flex: 1 }]}>
            Phone: {customer.phone}
          </Text>
        </View>

        {/* Table Header */}
        <View style={styles.tableRow}>
          <View style={[styles.cell, columnStyles.vehicle]}>
            <Text>Vehicle No</Text>
          </View>
          <View style={[styles.cell, columnStyles.date]}>
            <Text>Date</Text>
          </View>
          <View style={[styles.cell, columnStyles.qty]}>
            <Text style={styles.right}>Qty</Text>
          </View>
          <View style={[styles.cell, columnStyles.price]}>
            <Text style={styles.right}>Per Ltr</Text>
          </View>
          <View style={[styles.cell, columnStyles.grossAmount]}>
            <Text style={styles.right}>Act. Amount</Text>
          </View>
          <View style={[styles.cell, columnStyles.discount]}>
            <Text style={styles.right}>Disc.</Text>
          </View>
          <View style={[styles.cell, columnStyles.netAmount]}>
            <Text style={styles.right}>Total Amt.</Text>
          </View>
          <View style={[styles.cell, columnStyles.paid]}>
            <Text style={styles.right}>Amt. Paid</Text>
          </View>
          <View style={[styles.cell, columnStyles.due]}>
            <Text style={styles.right}>Total</Text>
          </View>
          {/* <View style={[styles.cell, columnStyles.status]}>
            <Text>Status</Text>
          </View> */}
        </View>

        {/* Orders */}
        {customer.orders.map((order, i) => (
          <View key={i} style={styles.tableRow}>
            <View style={[styles.cell, columnStyles.vehicle]}>
              <Text>{order.vehicle_no}</Text>
            </View>
            <View style={[styles.cell, columnStyles.date]}>
              <Text>{order.order_date}</Text>
            </View>
            <View style={[styles.cell, columnStyles.qty]}>
              <Text style={styles.right}>{order.total_qty}</Text>
            </View>
            <View style={[styles.cell, columnStyles.price]}>
              <Text style={styles.right}>
                {order.price_per_unit?.toFixed(2)}
              </Text>
            </View>
            <View style={[styles.cell, columnStyles.grossAmount]}>
              <Text style={styles.right}>
                {(order.total_amount + order.discount_amount).toFixed(2)}
              </Text>
            </View>
            <View style={[styles.cell, columnStyles.discount]}>
              <Text style={styles.right}>
                {order.discount_amount.toFixed(2)}
              </Text>
            </View>
            <View style={[styles.cell, columnStyles.netAmount]}>
              <Text style={styles.right}>{order.total_amount.toFixed(2)}</Text>
            </View>
            <View style={[styles.cell, columnStyles.paid]}>
              <Text style={styles.right}>{order.paid_amount.toFixed(2)}</Text>
            </View>
            <View style={[styles.cell, columnStyles.due]}>
              <Text style={styles.right}>
                {(order.total_amount - order.paid_amount).toFixed(2)}
              </Text>
            </View>
            {/* <View style={[styles.cell, columnStyles.status]}>
              <Text>{order.status}</Text>
            </View> */}
          </View>
        ))}
        {/* Totals */}
        <View style={styles.tableRow}>
          <Text style={[styles.cell, { flex: 3 }]}>Total Qty:</Text>
          <Text style={[styles.cell, styles.right]}>
            {customer.total_qty.toFixed(2)}
          </Text>
        </View>
        <View style={styles.tableRow}>
          <Text style={[styles.cell, { flex: 3 }]}>Total Amount:</Text>
          <Text style={[styles.cell, styles.right,styles.bold]}>
            {customer.total_amount.toFixed(2)}
          </Text>
        </View>

        {/* Bank Details */}
        {/* <View style={[styles.tableRow, { marginTop: 20 }]}>
          <View style={[styles.cell, { flex: 1 }]}>
            <Text style={styles.bold}>Bank Details</Text>
            <Text>Name: Axis Bank - Vejalpur Branch</Text>
            <Text>IFSC: UTI000058</Text>
            <Text>Account No: 2325240008455</Text>
          </View>
        </View> */}

        <View style={[styles.tableRow, { marginTop: 20 }]}>
          <View style={[styles.cell, { flex: 1 }]}>
            <Text style={styles.bold}>Remarks:-</Text>
            <Text>&nbsp; Payment is due within 10 days of the invoice date</Text>
            <Text>&nbsp; Late payments may incur a 2% monthly interest fee.</Text>
            <Text>&nbsp; Please include the invoice number in all correspondence.</Text>
            <Text>&nbsp; For any queries, call +91-92655 68766.</Text>
          </View>
        </View>

        <View style={{ marginTop: 80, textAlign: "right" }}>
          <Text>From:<br /> NAMASHKAR FUEL ENERGY OPC PVT</Text>
        </View>
      </Page>
    </Document>
  );
};

export default ReportPdf;
